import { render } from "./Apps.vue?vue&type=template&id=3bb6ee24"
import script from "./Apps.vue?vue&type=script&lang=js"
export * from "./Apps.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Apps.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3bb6ee24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3bb6ee24', __exports__)) {
    api.reload('3bb6ee24', __exports__)
  }
  
  module.hot.accept("./Apps.vue?vue&type=template&id=3bb6ee24", () => {
    api.rerender('3bb6ee24', render)
  })

}


export default __exports__